import { useRouter } from 'next/router';
import { Typography, Box } from '@mui/material';
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
} from 'react-share';

import { snackbarInfo } from 'store/utils';
import Facebook from '@public/assets/svg/ShareToFacebook.svg';
import Twitter from '@public/assets/svg/Twitter.svg';
import Copylink from '@public/assets/svg/Copylink.svg';
import Email from '@public/assets/svg/Email.svg';

import { useStyles } from './useStyles';

interface IShareToSocialMediaComponent {
  pageData: any;
}

const ShareToSocialMediaComponent = ({
  pageData,
}: IShareToSocialMediaComponent) => {
  const { seo_title } = pageData || {};

  const classes = useStyles();
  const shareUrl = window.location?.href;

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    snackbarInfo({
      message: 'Url Copied',
      type: 'success',
    });
  };

  return (
    <Box className={classes.mainContainer}>
      <Typography
        variant="body2"
        align="center"
        color="cinnamon.main"
        mb={{ xs: '20px', sm: '25px' }}
      >
        Share to Social Media
      </Typography>
      <Box className={classes.itemContainer}>
        <FacebookShareButton
          url={shareUrl}
          quote={seo_title}
          className={classes.icon}
        >
          <Facebook />
        </FacebookShareButton>

        <TwitterShareButton
          url={shareUrl}
          title={seo_title}
          className={classes.icon}
        >
          <Twitter />
        </TwitterShareButton>
        <a className={classes.icon} onClick={handleCopy}>
          <Copylink />
        </a>
        <EmailShareButton
          url={shareUrl}
          subject={seo_title}
          body={shareUrl}
          className={classes.icon}
        >
          <Email />
        </EmailShareButton>
      </Box>
    </Box>
  );
};

export default ShareToSocialMediaComponent;
